import { useAuth } from 'hooks/auth'

export const getSaveBlockedTooltip = (inProcess: boolean): string =>
  inProcess ? 'Upgrade to a paid license to save personal views' : 'Upgrade to a paid license to save views'

// Mirrors the backend's `@paid_subscription_required` on both
// POST /table/<table_id>/views and PUT /views/<id>: any non-paid user
// (subscriptionLevel !== PAID) is rejected before role checks run, so
// table-ownership is intentionally not an exemption here.
const usePersonalSaveBlocked = (): boolean => {
  const { user } = useAuth()

  return user?.subscriptionLevel === 0
}

export default usePersonalSaveBlocked
